module.exports = "/assets/386586c30ae9447256f308935859f2cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2V.png
// module id = 997
// module chunks = 0